import { t } from '@lingui/core/macro';

import ChevronRightIcon from '@/assets/svg/bx-chevron-right.svg?react';
import { cn } from '@/lib/utils';

import PaginationLink, { type PaginationLinkProps } from './PaginationLink';

export type PaginationNextProps = PaginationLinkProps;

const PaginationNext = ({ className, ...props }: PaginationNextProps) => {
  return (
    <PaginationLink aria-label={t`Go to next page`} className={cn(className)} {...props}>
      <ChevronRightIcon data-icon="inline-end" className="rtl:-scale-x-100" />
    </PaginationLink>
  );
};

export default PaginationNext;
